import angular from 'angular';
import CategoriesMenu from './categories-menu.component';

let CategoriesMenuModule = angular.module('catalog.categoriesMenu', [])
  .component('categoriesMenu', CategoriesMenu);

export default CategoriesMenuModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/categories-menu/categories-menu.js
 **/